export class CurrencyInfoModel {
  constructor() {
    this.currency_iso = 'USD';
    this.conversion_rate = 1;
    this.currency_symbol = '$';
    this.country_iso = 'US';
  }
};